<h1 mat-dialog-title>{{ input?.titel }}</h1>
<div mat-dialog-content>
    <kiene-signature-panel
        (saved)="setUnterschrift($event)"
        [hinweisText]="input?.hinweisText"
        [imgBase64]="input?.unterschriftBase64"
    ></kiene-signature-panel>
</div>
<div mat-dialog-actions>
    <button (click)="dialogRef.close()" mat-button>{{ input?.abbrechenText }}</button>
</div>
